import {
	CurrentPlanType,
	OrganizationInfoSuccessPayload,
	OrganizationState,
} from "@/redux/organization/types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getStateKeyList } from "@/utils/redux/state";
import { AppResponseDto, CompanyResponseDto } from "@/api/interface";
import { FetchStatus } from "@/redux/util/type";

const initialState: OrganizationState = {
	organizationInfoFetchState: "READY",
	currentPlan: null,
	companyInfo: null,
	companyDetailInfo: null,
	dashboardInfo: null,
	applicationInfo: null,
};

export const ORGANIZATION_STATE_KEY_LIST = getStateKeyList(initialState);

export const organizationSlice = createSlice({
	name: "organization",
	initialState,
	reducers: {
		reset: () => initialState,
		setCurrentPlan: (state, { payload }: PayloadAction<CurrentPlanType>) => {
			state.currentPlan = {
				...state.currentPlan,
				...payload,
			};
		},
		setCompanyInfo: (state, { payload }: PayloadAction<CompanyResponseDto>) => {
			state.companyInfo = {
				...state.companyInfo,
				...payload,
			};
		},
		setApplicationInfoById: (state, { payload }: PayloadAction<AppResponseDto>) => {
			if (!state.applicationInfo) {
				state.applicationInfo = [payload];
			}

			state.applicationInfo = [
				...state.applicationInfo.filter((v) => v.id !== payload.id),
				payload,
			];
		},
		deleteApplicationInfoById: (state, { payload }: PayloadAction<number>) => {
			if (!state.applicationInfo) {
				return;
			}

			state.applicationInfo = state.applicationInfo.filter((v) => v.id !== payload);
		},
		setOrganizationInfoFetchState: (
			state,
			{ payload }: PayloadAction<FetchStatus>,
		) => {
			state.organizationInfoFetchState = payload;
		},
		setOrganizationInfoFetchRequest: (state) => {
			state.organizationInfoFetchState = "PENDING";
		},
		setOrganizationInfoFetchSuccess: (
			state,
			{
				payload: {
					currentPlan,
					companyInfo,
					companyDetailInfo,
					dashboardInfo,
					applicationInfo,
				},
			}: PayloadAction<OrganizationInfoSuccessPayload>,
		) => {
			state.currentPlan = currentPlan;
			state.companyInfo = companyInfo;
			state.companyDetailInfo = companyDetailInfo;
			state.dashboardInfo = dashboardInfo;
			state.applicationInfo = applicationInfo;
			state.organizationInfoFetchState = "SUCCESS";
		},
		setOrganizationInfoFetchFail: (state) => {
			state.organizationInfoFetchState = "FAILURE";
		},
	},
});

export const organizationReducer = organizationSlice.reducer;
